import { render, staticRenderFns } from "./MoveArea.vue?vue&type=template&id=b7b11e98&scoped=true&"
import script from "./MoveArea.vue?vue&type=script&lang=js&"
export * from "./MoveArea.vue?vue&type=script&lang=js&"
import style0 from "./MoveArea.vue?vue&type=style&index=0&id=b7b11e98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b11e98",
  null
  
)

export default component.exports